import React from "react";
import { Modal, ModalBuilder, Table } from "@redriver/cinnamon";
import { deleteClientChangeRequest } from "features/Companies/Customers/Change Requests/actions";
import { Icon } from "semantic-ui-react";

const DeleteRequest = ({ requestId, onSubmitted }) => {
  return (
    <ModalBuilder
      submitAction={deleteClientChangeRequest}
      submitParams={requestId}
      onSubmitted={onSubmitted}
      renderTrigger={(showModal) => (
        <Table.MenuItem text="Delete" primary onClick={showModal} />
      )}
      renderModal={(modalProps, formProps, state, events) => (
        <Modal.Information
          header={
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <Icon
                name="close"
                color="red"
                style={{ cursor: "pointer", lineHeight: "1.6rem" }}
                onClick={() => events.onCancel()}
              />
            </div>
          }
          {...modalProps}
        >
          Are you sure you would like to delete this request?
        </Modal.Information>
      )}
    />
  );
};
export default DeleteRequest;
